<h2 mat-dialog-title class="cd-title">
  <mat-icon [class.warn]="data.warn">{{ data.warn ? 'warning' : 'help_outline' }}</mat-icon>
  <span>{{ data.title }}</span>
</h2>
<mat-dialog-content class="cd-content">
  <p class="cd-msg" [innerHTML]="data.html"></p>
  <app-select-date [label]="data.label" [date]="data.day" [calendarOpen]="true" (dateChange)="day = $event"></app-select-date>
  @if (!day) { <p class="cd-err">Date non comprise : tapez le jour (15, 15/10 ou 15/10/2026) ou choisissez-le dans le calendrier.</p> }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button type="button" mat-dialog-close>Annuler</button>
  <button mat-flat-button color="primary" type="button" id="confirmdatebutton" [disabled]="!day" (click)="confirm()">{{ data.confirm }}</button>
</mat-dialog-actions>
